import React from 'react';
import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import Place from '@material-ui/icons/Place';
import Mail from '@material-ui/icons/Mail';
import { TrashIcon } from '../../../images/icons/WrapSvg';
import MultiSelectInput from '../../inputs/MultiSelectInput';
import BlueButton from '../../buttons/BlueButton';
import Back from './backstep';

function isNotOkEmail(value) {
    return value ? !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) : false;
}

function init(id, timezone) {
    return {
        id: id,
        nombre: "",
        email: "",
        direccion: "",
        cp: "",
        poblacion: "",
        estado: "",
        pais: "",
        telefono: "",
        contacto: "",
        idioma: undefined,
        zona: timezone
    }
}

class Locals extends React.Component {

    state = {
        isLoading: false,
        save: false,
        current: init(randomstring(), undefined)
    }

    handleChangeCurrent = event => {
        const { current } = this.state;
        current[event.target.name] = event.target.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }


    handleTimezoneChange = input => {
        const { current } = this.state;
        current['zona'] = input.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handlePaisesChange = input => {
        const { current } = this.state;
        current['pais'] = input.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })  
    }

    handleLanguageChange = input => {
        const { current } = this.state;
        current['idioma'] = input.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleAddLocal = event => {
        if (this.localReady()) {
            let { onboarding } = this.props;
            const { current } = this.state;
            if (!onboarding.locales) {
                onboarding.locales = [];
            }
            current.id = randomstring();
            onboarding.locales.push({ ...current });
            this.props.onSave('locales', onboarding.locales);
            this.setState({
                save: false,
                current: init(randomstring(), 'Europe/Madrid')
            })
        }
    }

    handleEdit = index => event => {
        this.setState({ save: index, current: this.props.onboarding.locales[index] })
    }

    handleSaveLocal = event => {
        let { onboarding } = this.props;
        const { current, save } = this.state;
        onboarding.locales[save] = current;
        this.props.onSave('locales', onboarding.locales);
        this.setState({
            save: false,
            current: JSON.parse(JSON.stringify(init(randomstring(), 'Europe/Madrid')))
        })
    }

    handleDelete = index => event => {
        let { onboarding } = this.props;

        const { programaciones } = onboarding;

        const id = onboarding.locales[index].id;

        let temp = programaciones.map((p) => {
                p.programaciones = p.programaciones.reduce((arr, i) => {
                                                                if(i.local !== id) {
                                                                    arr.push(i);
                                                                }
                                                                return arr;
                                                            }, [])
                return p;
            })

        onboarding.locales.splice(index, 1);
        this.props.onSave('locales', onboarding.locales);
        this.props.onSave('programaciones', temp);

        this.setState({
            save: false,
            current: JSON.parse(JSON.stringify(init(randomstring(), 'Europe/Madrid')))
        })
    }

    localReady = () => {
        const { current } = this.state;
        return current.nombre
            && current.email && !isNotOkEmail(current.email)
            && current.direccion
            && current.cp
            && current.poblacion
            && current.estado
            && current.pais
            && current.telefono
            && current.contacto;
    }

    render() {
        const { current, save } = this.state;
        const { intl, onboarding, quota, timezones, idiomas, paises  } = this.props;
        const { locales } = onboarding;
        console.log(quota, locales.length);
        return (
            <div className="ob_step">
                <Back {...this.props} />
                <div className="flex_full_row padding_borders_flat center">
                    <div className="ob_welcome text_align_left_important">
                        <div className="ob_locals padding_top_12">
                            {(locales && locales.length > 0) &&
                                locales.map((i, index) =>
                                    <div key={'local_bt_' + index} className="flex_auto_row margin_right_6">
                                        <div className="ob_local_button" onClick={this.handleEdit(index)}>
                                            <div className="flex_full_row width100 elements_from_right align_center margin_bottom_12">
                                                <div className="flex_full_row width100  ob_local_bt_index">
                                                    {'#' + (index + 1)}
                                                </div>
                                            </div>
                                            <span className="ob_local_button_title hand">{i.nombre}</span>
                                        </div>
                                        <div className="ob_trash">
                                            <TrashIcon
                                                className="hand ob_local_bt_trash"
                                                color={'secondary'}
                                                onClick={this.handleDelete(index)}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="flex_auto_row width100 align_baseline">
                            <Place className="margin_right_6" />
                            <TextField
                                fullWidth
                                id={'nombre'}
                                name={'nombre'}
                                required
                                label={intl.formatMessage({ id: 'form_field_name_nombre_local' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.nombre ? current.nombre : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 align_baseline ">
                            <Mail className="margin_right_6" />
                            <TextField
                                fullWidth
                                id={'email'}
                                name={'email'}
                                required
                                error={isNotOkEmail(current.email)}
                                helperText={
                                    isNotOkEmail(current.email)
                                        ? intl.formatMessage({ id: 'email_format_error' })
                                        : ''
                                }
                                label={intl.formatMessage({ id: 'form_field_name_email' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.email ? current.email : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 ob_locals_email_message">
                            {intl.formatMessage({ id: 'ob_locals_email_message' })}
                        </div>
                        <div className="flex_auto_row width100 align_center ">
                            <TextField
                                fullWidth
                                id={'direccion'}
                                name={'direccion'}
                                required
                                label={intl.formatMessage({ id: 'ob_address' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.direccion ? current.direccion : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 align_center ">
                            <TextField
                                fullWidth
                                id={'cp'}
                                name={'cp'}
                                required
                                label={intl.formatMessage({ id: 'ob_cp' })}
                                className={'flex_full_row margin_bottom_12 margin_right_12'}
                                value={current.cp ? current.cp : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'poblacion'}
                                name={'poblacion'}
                                required
                                label={intl.formatMessage({ id: 'ob_local' })}
                                className={'flex_full_row margin_bottom_12 margin_right_12'}
                                value={current.poblacion ? current.poblacion : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'estado'}
                                name={'estado'}
                                required
                                label={intl.formatMessage({ id: 'ob_province' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.estado ? current.estado : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_row width100 align_center ">
                            <MultiSelectInput
                                defaultValue={[paises.find((f) => f.value === current['pais'])]}
                                placeHolder={intl.formatMessage({
                                    id: 'ob_country',
                                })}
                                options={paises}
                                onChange={this.handlePaisesChange}
                                isSimple
                            />
                            <MultiSelectInput
                                defaultValue={[timezones.find((f) => f.value === current['zona'])]}
                                placeHolder={intl.formatMessage({
                                    id: 'ob_timezone',
                                })}
                                options={timezones}
                                extraClass="margin_left_12"
                                onChange={this.handleTimezoneChange}
                                isSimple
                            />
                        </div>
                        <div className="flex_auto_row width100 align_center ">
                            <TextField
                                fullWidth
                                id={'telefono'}
                                name={'telefono'}
                                required
                                label={intl.formatMessage({ id: 'form_field_name_phone' })}
                                className={'flex_full_row margin_bottom_12 margin_right_12 ob_margin_top'}
                                value={current.telefono ? current.telefono : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                            <TextField
                                fullWidth
                                id={'contacto'}
                                name={'contacto'}
                                required
                                label={intl.formatMessage({ id: 'form_field_name_contact' })}
                                className={'flex_full_row margin_bottom_12 margin_right_12 ob_margin_top'}
                                value={current.contacto ? current.contacto : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                            <MultiSelectInput
                                defaultValue={[idiomas.find((f) => f.value === current['idioma'])]}
                                placeHolder={intl.formatMessage({
                                    id: 'ob_language',
                                })}
                                options={idiomas}
                                onChange={this.handleLanguageChange}
                                isSimple
                            />
                        </div>
                        <div className="flex_auto_row width100 align_center elements_from_right">
                            {save !== false &&
                                <button className={"ob_add margin_right_12 " + (!this.localReady() ? 'c_disabled' : 'c_slate')} onClick={this.handleSaveLocal} >
                                    {intl.formatMessage({ id: 'ob_save' })}
                                </button>
                            }
                            {(!locales || !quota || (locales && locales.length < quota)) &&
                                <button className={"ob_add " + (!this.localReady() ? 'c_disabled' : 'c_slate')} onClick={this.handleAddLocal} >
                                    {intl.formatMessage({ id: 'ob_add' })}
                                </button>
                            }
                        </div>
                    </div>
                </div>
                <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                    <BlueButton id="next" className="ob_next" onClick={this.props.onNext} />
                </div>
            </div>

        );



    }
}

export default Locals;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/locals.js